import { Controller } from "@hotwired/stimulus"
import "lightgallery.js/dist/js/lightgallery.min.js"

export default class extends Controller {
  connect() {
    // lightGallery 1.x attaches itself to the global window object or the element
    // Initialize the gallery on the controller's element
    lightGallery(this.element)

    // Store a reference to the gallery instance for cleanup
    // In v1.x, the instance is stored internally by the library
    this.galleryId = this.element.getAttribute('lg-uid')
  }

  disconnect() {
    // Clean up the gallery instance when the controller is removed
    if (this.galleryId && window.lgData && window.lgData[this.galleryId]) {
      window.lgData[this.galleryId].destroy(true)
    }
  }
}
